import {
  firstOf,
  getAtOffset,
  lengthOf,
  SpeculatedArray,
} from './speculated-array';
import {
  Message,
  StateUpdateMessage,
  TextMessage,
  WidgetActionMessage,
} from '../models/threads';
import { WidgetLookups } from '../store/endpoints/threads';

export function getOriginatingQueryText(
  allMessages: SpeculatedArray<Message>,
  widgetCaches: WidgetLookups,
): string | undefined {
  if (lengthOf(widgetCaches.stateIndexes) === 0) {
    return undefined;
  }

  const firstStateMessageOffset = firstOf(widgetCaches.stateIndexes);
  const firstStateMessage = getAtOffset(
    allMessages,
    firstStateMessageOffset,
  ) as StateUpdateMessage;

  const firstActionMessage = getAtOffset(
    allMessages,
    firstStateMessage.predecessorOffsetInThread,
  ) as WidgetActionMessage;

  const userMessage = getAtOffset(
    allMessages,
    firstActionMessage.predecessorOffsetInThread,
  ) as TextMessage;

  return userMessage.text;
}
